import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { ActivitiesLiteComponent } from '../activities-lite/activities-lite.component';
import { ActivitiesComponent } from '../activities/activities.component';
import { ErrorComponent } from '../error/error.component';
import { LayoutComponent } from '../layout/layout.component';
import { SurveyMainComponent } from '../survey-main/survey-main.component';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

const routes: Routes = [

  {
    matcher: userMatch,
    component: LayoutComponent
  },
  {
    matcher: activityMatch,
    component: ActivitiesComponent
  },
  {
    path: 'v2/activities',
    loadChildren: () => import('../activities-lite/activities-lite.module').then(m => m.ActivitiesLiteModule)
  },
  {
    matcher: feedbackMatch,
    component: SurveyMainComponent
  },
  {
    path: '**',
    component: ErrorComponent
    // loadChildren: () => new Promise(() => { window.location.href = environment.redirectToAdminPortal; })
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'}),
  GoogleTagManagerModule.forRoot({
    id: sessionStorage.getItem('GTMCode') || ''
  })],
  exports: [RouterModule]
})
export class CoreRoutingModule {

}

export function userMatch(url: UrlSegment[]): UrlMatchResult {

  if(url[0].path.match('xxx')){
    url[0].path = 'online';
  }
  
  if (url.length === 4 && url[0].path.match('online') && url[1].path.match('restaurants') && url[3].path.match('iframe')) {
    url = getModifiedRestaurantUrl(url);
    return {
      consumed: url,
      posParams: {
        restaurantName: new UrlSegment(url[2].path, {})
      }
    };
  }
  else if (url.length === 4 && url[0].path.match('orders') && url[1].path && url[2].path && url[3].path) {
    return {
      consumed: url,
      posParams: {
        restaurantToken: new UrlSegment(url[1].path, {}),
        operation: new UrlSegment(url[2].path, {}),
        language: new UrlSegment(url[3].path, {})
      }
    };
  }
  else if (url.length === 3 && url[0].path && url[1].path.match('restaurants') && url[2].path) {
    
    url = getModifiedRestaurantUrl(url);
    
    return {
      consumed: url,
      posParams: {
        pageName: new UrlSegment(url[0].path, {}),
        restaurantName: new UrlSegment(url[2].path, {})
      }
    };
  }
  else if (url.length === 5 && url[0].path.match('online') && url[1].path.match('restaurants') && url[3].path.match('iframe')
  ) {

    url = getModifiedRestaurantUrl(url);

    return {
      consumed: url,
      posParams: {
        restaurantName: new UrlSegment(url[2].path, {}),
        specialMealIdFromURL : new UrlSegment(url[4].path, {})
      }
    };
  }
  return null;
}

function getModifiedRestaurantUrl(url: UrlSegment[]): UrlSegment[]{

  if(url[2].path.includes('xxx')){
    let splitUrltext = url[2].path.split('xxx');
    if(splitUrltext[1]){
      url[2].path = url[2].path.replace('xxx', '');
    }else{
      url[2].path = url[2].path.replace('-xxx', '');
    }

    while(url[2].path.includes('--')){
      url[2].path = url[2].path.replace("--","-")
    }
  }

  return url;

}



export function activityMatch(url: UrlSegment[]): UrlMatchResult {

  if(url[0].path.match('xxx')){
    url[0].path = 'online';
  }

  if (url.length === 4 && url[0].path.match('online') && url[1].path.match('activities') && url[3].path.match('iframe')) {
    return {
      consumed: url,
      posParams: {
        restaurantName: new UrlSegment(url[2].path, {})
      }
    };
  }
  else if (url.length === 5 && url[0].path.match('booking') && url[1].path && url[2].path && url[3].path && url[4].path) {
    return {
      consumed: url,
      posParams: {
        restaurantToken: new UrlSegment(url[1].path, {}),
        bookingType: new UrlSegment(url[2].path, {}),
        operation: new UrlSegment(url[3].path, {}),
        language: new UrlSegment(url[4].path, {})
      }
    };
  }
  return null;

}

export function feedbackMatch(url: UrlSegment[]): UrlMatchResult {

  if (url.length === 5 && url[0].path.match('feedback')) {
    return {
      consumed: url,
      posParams: {
        restaurantName: new UrlSegment(url[1].path, {}),
        partyToken: new UrlSegment(url[2].path, {}),
        languageId: new UrlSegment(url[3].path, {}),
        contactId: new UrlSegment(url[4].path, {})
      }
    };
  }
  return null;
}